import * as React from 'react';
import './edit-modal.scss';
import { Modal } from '../../../../../components/modal/modal';
import { updateTransaction } from '../../../../../core/repositories/orders-transactions';
import { Dropdown } from 'components/dropdown/dropdown';
import { Button, buttonType } from 'components/button/button';
import { Enum } from 'core/domain/commons/common';
import { Input } from 'components/input/input';
import { Transaction } from 'core/domain/transaction/transaction';
import { Dispatch, FC, SetStateAction, useEffect, useState } from 'react';

interface Props {
    isOpen: boolean;
    setIsOpen: Dispatch<SetStateAction<boolean>>;
    item: Transaction;
    onClose: () => void;
    transactionStates: Enum[];
}

export const TransactionEditModal: FC<Props> = ({ isOpen, setIsOpen, item, onClose, transactionStates }) => {
    const [buttonLoading, setButtonLoading] = useState(false);
    const [walletAddress, setWalletAddress] = useState<string>(item.wallet?.walletAddress);
    const [txId, setTxId] = useState<string>(item.txId ?? '');
    const [selectedState, setSelectedState] = useState<Enum>(
        transactionStates.filter((q) => q.title === item.state.title)[0],
    );

    const onCloseModal = () => {
        onClose();
    };

    useEffect(() => {
        if (isOpen === false) onCloseModal();
    }, [isOpen]);

    useEffect(() => {
        setWalletAddress(item.wallet?.walletAddress);
        setTxId(item.txId ?? '');
        setSelectedState(transactionStates.filter((q) => q.title === item.state.title)[0]);
    }, [item]);

    return (
        <Modal title="تغییر تراکنش" className="transaction-edit-modal" isOpen={isOpen} setIsOpen={setIsOpen}>
            <div className="content">
                <div className="row">
                    <label>تغییر وضعیت تراکنش</label>
                    {transactionStates?.length > 0 && (
                        <Dropdown
                            items={transactionStates.filter((item) => item.id > 0)}
                            onChangeHandle={(value) =>
                                setSelectedState(transactionStates.filter((item) => item.id === value)[0])
                            }
                            selectedOption={selectedState}
                        />
                    )}
                </div>
                <div className="row">
                    <label>تغییر آدرس کیف پول</label>
                    <Input
                        className={!!walletAddress ? 'en' : ''}
                        dir={!!walletAddress ? 'ltr' : 'rtl'}
                        placeholder="آدرس کیف پول را وارد کنید"
                        value={walletAddress}
                        onChange={(e) => setWalletAddress(e.target.value)}
                    />
                </div>
                <div className="row">
                    <label>تغییر هش</label>
                    <Input
                        className={!!txId ? 'en' : ''}
                        dir={!!txId ? 'ltr' : 'rtl'}
                        placeholder="TxId را وارد کنید"
                        value={txId}
                        onChange={(e) => setTxId(e.target.value)}
                    />
                </div>

                <div className="buttons">
                    <Button
                        loading={buttonLoading}
                        type={buttonType.info}
                        text="اعمال تغییرات"
                        onClick={async (e) => {
                            if (item.id) {
                                await updateTransaction(
                                    setButtonLoading,
                                    {
                                        id: item.id,
                                        walletAddress: walletAddress || null,
                                        txId: txId || null,
                                        state: selectedState.id,
                                    },
                                    (e) => {
                                        onClose();
                                    },
                                );
                            }
                        }}
                    />
                    <Button type={buttonType.outlined} text="بازگشت" onClick={() => setIsOpen(false)} />
                </div>
            </div>
        </Modal>
    );
};
